<template>
  <div class="panel">
    <div id="page-header">
      <img v-if="isChinaVersion()" src="@/assets/aidex_logo.svg" alt="" />
      <div v-if="isChinaVersion()" class="info-one">
        <div class="title">{{ $t('reportTitle') }}</div>
      </div>
      <!-- <div class="info-one-en">
        <img src="@/assets/aidex_eu_logo.svg" alt="" />
        <div class="title">{{ $t('reportTitle') }}</div>
      </div> -->
      <div :class="isChinaVersion() ? 'divider' : 'divider-ghost'"></div>
      <div class="info-two">
        <div class="left-info">
          <div>{{ $t('name') }}: {{ baseInfo.name }}</div>
          <div>{{ $t('cgmSn') }}: {{ baseInfo.device }}</div>
        </div>
        <div class="right-info">
          <div>
            {{ $t('monitorDays') }}: {{ startDate }} - {{ endDate }}
            {{ $tc('unit.day', cgmRecord.glucose.length) }}
          </div>
          <div>{{ $t('serialNo') }}:{{ serialNo }}</div>
        </div>
      </div>
    </div>
    <div id="page-footer"></div>
    <table class="main-content">
      <thead>
        <tr>
          <td>
            <div class="page-header-space"></div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="container">
              <div class="header">
                <div>{{ $t('reportTitle') }}</div>
              </div>
              <div class="tips">
                <div class="border"></div>
                <div class="label">{{ $t('title.baseInfo') }}</div>
              </div>
              <div class="base-info">
                <div class="info">
                  <div class="person-info">
                    <div class="info-item">
                      <div>{{ $t('name') }}: {{ baseInfo.name || "--" }}</div>
                    </div>
                    <div class="info-item">
                      <div>
                        {{ $t('sex') }}: {{ baseInfo.gender }}
                      </div>
                    </div>
                    <div class="info-item">
                      <div>{{ $t('age') }}: {{ patientAge }}</div>
                    </div>
                    <div class="info-item">
                      <div>{{ $t('diagnosis') }}: {{ baseInfo.diagnosis || "--" }}</div>
                    </div>
                    <div class="info-item">
                      <div>{{ $t('height') }}: {{ baseInfo.height ? `${baseInfo.height} ${$t('unit.m')}` : "--" }}</div>
                    </div>
                    <div class="info-item">
                      <div>{{ $t('weight') }}: {{ baseInfo.weight ? `${baseInfo.weight} ${$t('unit.kg')}` : "--" }}</div>
                    </div>
                    <div class="info-item">
                      <div v-if="isChinaVersion()">{{ $t('phone') }}: {{ baseInfo.phone || "--" }}</div>
                      <div v-else>{{ $t('email') }}: {{ baseInfo.email || "--" }}</div>
                    </div>
                    <div class="info-item">
                      <div>{{ $t('cgmSn') }}: {{ baseInfo.device || "--" }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tips">
                <div class="border"></div>
                <div class="label">{{ $t('title.cgmInfo') }}</div>
              </div>
              <div class="cgm-core">
                <div :class="isRussiaVersion() ? 'left-panel ru' : 'left-panel'">
                  <table border="0" cellspacing="0" cellpadding="4">
                    <tr>
                      <th>{{ $t('cgmInfo.indicator') }}</th>
                      <th>{{ $t('cgmInfo.unit') }}</th>
                      <th>{{ $t('cgmInfo.result') }}</th>
                      <th>{{ $t('cgmInfo.reference') }}</th>
                    </tr>
                    <tr>
                      <td>{{ $t('cgmInfo.cgmDays') }}</td>
                      <td>{{ $t('unit.oneDay') }}</td>
                      <td>
                        <span>{{ cgmRecord.glucose.length }}</span>
                      </td>
                      <td>&gt; 14</td>
                    </tr>
                    <tr>
                      <td>{{ $t('cgmInfo.cgmActive') }}</td>
                      <td>%</td>
                      <td>
                        <span>{{ cgmActive }}</span>
                      </td>
                      <td>&gt; 70</td>
                    </tr>
                    <tr>
                      <td>{{ $t('cgmInfo.ehba1c') }}</td>
                      <td>%</td>
                      <td>
                        <span>{{ formatterIndicator(cgmRecord.ehba1c) }}</span>
                        <arrow :value="cgmRecord.ehba1c" :lt="7" />
                      </td>
                      <td>&lt; 7</td>
                    </tr>
                    <tr>
                      <td>{{ $t('cgmInfo.mbg') }}</td>
                      <td>{{ $t('unit.mmolL') }}</td>
                      <td>
                        <span>{{ formatterIndicator(dataFirstPage(cgmRecord.mbg)) }}</span>
                        <arrow :value="dataFirstPage(cgmRecord.mbg)" :gt="4.3" :lt="6.6" />
                      </td>
                      <td>{{ formatterConstantComma(4.3) }} - {{ formatterConstantComma(6.6) }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t('cgmInfo.cv') }}</td>
                      <td>%</td>
                      <td>
                        <span>{{ formatterIndicator(dataFirstPage(cgmRecord.cv)) }}</span>
                        <arrow :value="dataFirstPage(cgmRecord.cv)" :lt="36.01" />
                      </td>
                      <td>≤36</td>
                    </tr>
                  </table>
                </div>
                <div class="right-panel">
                  <div class="tir-title">{{ $t('tirChart.title') }}</div>
                  <div class="tir-panel">
                    <div id="tir"></div>
                    <div class="legend">
                      <div :class="isTirTooLong() ? 'legend-item-long legend-item' :'legend-item'">
                        <div class="icon"></div>
                        <div>{{ `${$t('tirChart.prettyHigh')}${$t('unit.colon')} ${$t('tirChart.prettyHighEx')}` }}</div>
                      </div>
                      <div :class="isTirTooLong() ? 'legend-item-long legend-item' :'legend-item'">
                        <div class="icon"></div>
                        <div>{{ `${$t('tirChart.high')}${$t('unit.colon')} ${$t('tirChart.highEx')}` }}</div>
                      </div>
                      <div :class="isTirTooLong() ? 'legend-item-long legend-item' :'legend-item'">
                        <div class="icon"></div>
                        <div>{{ `${$t('tirChart.normal')}${$t('unit.colon')} ${$t('tirChart.normalEx')}` }}</div>
                      </div>
                      <div :class="isTirTooLong() ? 'legend-item-long legend-item' :'legend-item'">
                        <div class="icon"></div>
                        <div>{{ `${$t('tirChart.low')}${$t('unit.colon')} ${$t('tirChart.lowEx')}` }}</div>
                      </div>
                      <div :class="isTirTooLong() ? 'legend-item-long legend-item' :'legend-item'">
                        <div class="icon"></div>
                        <div>{{ `${$t('tirChart.prettyLow')}${$t('unit.colon')} ${$t('tirChart.prettyLowEx')}` }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div :class="isChinaVersion() ? 'tips' : 'tips tips-mt4'">
                <div class="border"></div>
                <div class="label">{{ $t('title.agp') }}</div>
              </div>
              <div class="agp-info">
                <div class="legend">
                  <div class="item">
                    <div class="b1"></div>
                    <div>50 % {{ $t('agpChart.median') }}</div>
                  </div>
                  <div class="item">
                    <div class="b2"></div>
                    <div>25 % - 75 % {{ $t('agpChart.interval') }}</div>
                  </div>
                  <div class="item">
                    <div class="b3"></div>
                    <div>10 % - 90 % {{ $t('agpChart.interval') }}</div>
                  </div>
                </div>
                <div id="agp"></div>
              </div>
              <div class="tips">
                <div class="border"></div>
                <div class="label">{{ $t('title.multiDay') }}</div>
              </div>
              <div id="multi_glu"></div>
              <div class="new-page"></div>
              <div class="tips">
                <div class="border"></div>
                <div class="label">{{ $t('title.gluEvent') }}</div>
              </div>
              <div class="glu-event">
                <table border="0" cellspacing="0" cellpadding="4">
                  <tr>
                    <th>{{ $t('gluEvent.indicator') }}</th>
                    <th>&lt; {{ formatterConstantComma(2.8) }} {{ $t('unit.mmolL') }}</th>
                    <th>&lt; {{ formatterConstantComma(3.3) }} {{ $t('unit.mmolL') }}</th>
                    <th>&lt; {{ formatterConstantComma(3.9) }} {{ $t('unit.mmolL') }}</th>
                    <th>&gt; {{ formatterConstantComma(10) }} {{ $t('unit.mmolL') }}</th>
                    <th>&gt; {{ formatterConstantComma(13.9) }} {{ $t('unit.mmolL') }}</th>
                    <th>&gt; {{ formatterConstantComma(22.2) }} {{ $t('unit.mmolL') }}</th>
                  </tr>

                  <tr>
                    <td>{{ $t('gluEvent.perDayHours') }}</td>
                    <td>{{ tirVal([0], true).hour }}</td>
                    <td>{{ tirVal([0, 1], true).hour }}</td>
                    <td>{{ tirVal([0, 1, 2], true).hour }}</td>
                    <td>{{ tirVal([5, 6, 7], true).hour }}</td>
                    <td>{{ tirVal([6, 7], true).hour }}</td>
                    <td>{{ tirVal([7], true).hour }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('gluEvent.perDayEvents') }}</td>
                    <td>
                      {{ formatterIndicator(dataFirstPage(cgmRecord.lbgd28).times) }}
                    </td>
                    <td>
                      {{ formatterIndicator(dataFirstPage(cgmRecord.lbgd33).times) }}
                    </td>
                    <td>
                      {{ formatterIndicator(dataFirstPage(cgmRecord.lbgd39).times) }}
                    </td>
                    <td>
                      {{ formatterIndicator(dataFirstPage(cgmRecord.lbgd100).times) }}
                    </td>
                    <td>
                      {{ formatterIndicator(dataFirstPage(cgmRecord.lbgd139).times) }}
                    </td>
                    <td>
                      {{ formatterIndicator(dataFirstPage(cgmRecord.lbgd222).times) }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('gluEvent.perDayDuration') }}</td>
                    <td>
                      {{ formatterIndicator(dataFirstPage(cgmRecord.lbgd28).meanDuration) }}
                    </td>
                    <td>
                      {{ formatterIndicator(dataFirstPage(cgmRecord.lbgd33).meanDuration) }}
                    </td>
                    <td>
                      {{ formatterIndicator(dataFirstPage(cgmRecord.lbgd39).meanDuration) }}
                    </td>
                    <td>
                      {{ formatterIndicator(dataFirstPage(cgmRecord.lbgd100).meanDuration) }}
                    </td>
                    <td>
                      {{ formatterIndicator(dataFirstPage(cgmRecord.lbgd139).meanDuration) }}
                    </td>
                    <td>
                      {{ formatterIndicator(dataFirstPage(cgmRecord.lbgd222).meanDuration) }}
                    </td>
                  </tr>
                </table>
                <div class="comment">{{ $t('gluEvent.tips') }}</div>
              </div>
              <div v-if="isChinaVersion()" class="tips">
                <div class="border"></div>
                <div class="label">血糖五角模型</div>
              </div>
              <div v-if="isChinaVersion()" class="pentagon-panel">
                <div class="average">
                  <div>多日平均值（{{ startDateTime }}-{{ endDateTime }}）</div>
                  <div id="pentagon"></div>
                </div>
                <div class="area">
                  <div>多日面积柱形图（{{ startDateTime }}-{{ endDateTime }}）</div>
                  <div id="area"></div>
                </div>
              </div>
              <div v-if="isChinaVersion()" class="pentagon-table">
                <table border="0" cellspacing="0" cellpadding="4">
                  <tr>
                    <th style="width: 21%">日期</th>
                    <th v-for="(item, index) in cgmRecord.glucose" :key="index">
                      {{ dateFormatter(index, 'MM/DD') }}
                    </th>
                  </tr>
                  <tr v-for="(item, pIndex) in new Array(7).fill(0)" :key="pIndex">
                    <td>
                      <span>{{ getPentagonTableItem(pIndex)[0] }}</span><br /><span>{{ getPentagonTableItem(pIndex)[1] }}</span>
                    </td>
                    <td v-for="(item, index) in cgmRecord.glucose" :key="index">
                      <div v-if="pIndex === 0" :id="bindPentagonId(index)" class="chart"></div>
                      <span v-else>{{ getPentagonTableTdContent(pIndex, index) }}</span>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- <div class="tips">
                <div class="border"></div>
                <div class="label">{{ $t('title.dailyGluMini') }}</div>
              </div>
              <div class="mini-glu-panel">
                <div v-for="(item, index) in cgmRecord.glucose" :key="index" class="mini-day-glu-item">
                  <div class="date">
                    <div>{{ dateFormatter(index, 'MM-DD') }}</div>
                  </div>
                  <div :id="bindMiniGluItemChartId(index)" class="chart"></div>
                </div>
              </div> -->
              <div v-if="isChinaVersion()" class="new-page"></div>
              <div class="tips" style="margin-bottom: 10px">
                <div class="border"></div>
                <div class="label">{{ $t('title.dailyGlu') }}</div>
                <!-- <div class="comment">每日血糖曲线中仅展示10个事件记录，超过部分不展示</div> -->
              </div>
              <div v-for="(item, index) in cgmRecord.glucose" :key="index" class="day-glu-item aviod-new-page">
                <div class="chart-panel">
                  <div v-if="isChinaVersion()" class="date">
                    <div>{{ perDayGluDateFormatter(index) }}</div>
                  </div>
                  <div v-else class="en-date">
                    <div>{{ perDayGluDateFormatter(index)[0] }}</div>
                    <div style="height: 10px"></div>
                    <div>{{ perDayGluDateFormatter(index)[1] }}</div>
                  </div>
                  <div :id="bindGluItemChartId(index)" class="chart"></div>
                </div>
                <div class="event-panel">
                  <div v-for="(item, index) in getEventMapByOffsetIndex(index)" :key="index">
                    <img v-if="item.eventType === 1" src="@/assets/event1.png" alt="" />
                    <img v-if="item.eventType === 2" src="@/assets/event2.png" alt="" />
                    <img v-if="item.eventType === 3" src="@/assets/event3.png" alt="" />
                    <img v-if="item.eventType === 4" src="@/assets/event4.png" alt="" />
                    <span class="event-label">
                      {{ getEventLabel(item) }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="new-page"></div>
              <div class="tips">
                <div class="border"></div>
                <div class="label">{{ $t('title.dailyStatistics') }}</div>
              </div>
              <!-- eslint-disable-next-line -->
              <div v-for="(dayGlucose, tableIndex) in statisticRecord">
                <div v-if="tableIndex > 0 && tableIndex % 2 === 0" class="new-page"></div>
                <div class="glu-overview">
                  <table border="0" cellspacing="0" cellpadding="4">
                    <tr>
                      <th>{{ $t('dailyStatistics.indicator') }}</th>
                      <th v-for="(item, index) in dayGlucose" :key="index">
                        {{ dateFormatter(item, "MM/DD") }}
                      </th>
                    </tr>
                    <tr
                      v-for="(item, pIndex) in new Array(15).fill(0)"
                      :key="pIndex"
                    >
                      <td style="width: 22%">
                        {{ getDayDataOverview(pIndex)[0] }}
                      </td>
                      <td
                        v-for="dayIndex in dayGlucose"
                        :key="dayIndex"
                        :class="{ 'bar-item': pIndex === 14 }"
                      >
                        <span v-if="pIndex < 14">{{
                          getDayDataOverviewContent(pIndex, dayIndex)
                        }}</span>
                        <div v-show="isShowGluPercent(dayIndex)" class="highBar">
                          <div
                            class="normalBar"
                            :style="{
                              height: +`${getDayDataOverviewContent(11, dayIndex)}`.replace(',', '.') + +`${getDayDataOverviewContent(13, dayIndex)}`.replace(',', '.') + '%',
                            }"
                          ></div>
                          <div
                            class="lowBar"
                            :style="{
                              height: (getDayDataOverviewContent(11, dayIndex) + '%').replace(',', '.'),
                            }"
                          ></div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="last-tip">
                <div class="day-glu-overview">
                  <div class="p1">
                    <div class="block3"></div>
                    <div class="tip-label">{{ $t('tirChart.high') }} (&gt; {{ formatterConstantComma(10.0) }} {{ $t('unit.mmolL') }})</div>
                  </div>
                  <div class="p2">
                    <div class="block1"></div>
                    <div class="tip-label">{{ $t('tirChart.normal') }} ( {{ formatterConstantComma(3.9) }} - {{ formatterConstantComma(10.0) }} {{ $t('unit.mmolL') }})</div>
                  </div>
                  <div class="p3">
                    <div class="block2"></div>
                    <div class="tip-label">{{ $t('tirChart.low') }} (&lt; {{ formatterConstantComma(3.9) }} {{ $t('unit.mmolL') }})</div>
                  </div>
                </div>
                <div class="gist">
                  {{ $t('overview.title') }}<br />
                  {{ $t('overview.content', [
                    formatterIndicator(dataFirstPage(cgmRecord.num)),
                    formatterIndicator(dataFirstPage(cgmRecord.mbg)),
                    formatterIndicator(dataFirstPage(cgmRecord.sdbg)),
                    formatterIndicator(dataFirstPage(cgmRecord.cv)),
                    formatterIndicator(dataFirstPage(cgmRecord.maxbg)),
                    formatterIndicator(dataFirstPage(cgmRecord.minbg)),
                    formatterConstantComma(+tirTimeRange.n.value),
                    tirVal([4, 5, 6, 7]).value,
                    tirVal([5, 6, 7]).value,
                    tirVal([6, 7]).value,
                    tirVal([0, 1, 2]).time,
                    tirVal([0, 1, 2]).value,
                    tirVal([0]).time,
                    tirVal([0]).value
                  ]) }}
                </div>
              </div>
              <div v-if="cgmRecord.glucose.length > 15 && Math.ceil(cgmRecord.glucose.length / 15) % 2 === 0" class="new-page"></div>
              <div class="annotation">
                <div style="font-weight: 500">{{ $t('annotation.title') }}</div>
                <div>1. {{ $t('annotation.one') }}</div>
                <div>2. {{ $t('annotation.two') }}</div>
                <div>3. {{ $t('annotation.three') }}</div>
                <div>4. {{ $t('annotation.four') }}</div>
                <div>5. {{ $t('annotation.five') }}</div>
                <div>6. {{ $t('annotation.six') }}</div>
                <div>7. {{ $t('annotation.seven') }}</div>
                <div>8. {{ $t('annotation.eight') }}</div>
                <div>9. {{ $t('annotation.nine') }}</div>
                <div>10. {{ $t('annotation.ten') }}</div>
                <div>11. {{ $t('annotation.eleven') }}</div>
                <div style="font-weight: 500;margin-top:20px">{{ $t('annotation.reference') }}</div>
                <div>{{ $t('annotation.rfOne') }}</div>
                <div>{{ $t('annotation.rfTwo') }}</div>
                <div>{{ $t('annotation.rfThree') }}</div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>
            <div class="page-footer-space"></div>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>
<script>
import { cgmApi } from '@/util/api'
import dayjs from 'dayjs'
import arrow from '@/components/Arrow'
import mixins from '@/mixins'

export default {
  name: 'Aidex',
  components: {
    arrow
  },
  mixins: [mixins],
  data() {
    return {
      loadingInstance: null,
      baseInfo: {},
      startDate: '',
      endDate: '',
      startDateTime: '',
      endDateTime: '',
      serialNo: +new Date(),
      cgmActive: null,
      cgmRecord: {
        eventMap: {},
        mage: [],
        num: [],
        mbg: [],
        maxbg: [],
        minbg: [],
        sdbg: [],
        pentagon: [],
        grade: {
          grade: 0
        },
        glucose: [],
        tir: {
          tir: []
        },
        lbgd28: [],
        lbgd39: [],
        lbgd100: [],
        lbgd139: [],
        lbgd222: []
      }
    }
  },
  mounted() {
    window.onbeforeprint = () => {
      window.history.pushState('', '', '/')
    }
    window.onafterprint = () => window.history.back()
    window.addEventListener('message', (res) => {
      if (res.data.type === 'print') {
        window.print()
      }
    })
    if (window.navigator.userAgent.indexOf('Firefox') > -1) {
      const pentagonTable = document.getElementsByClassName('pentagon-table')[0]
      if (pentagonTable) {
        pentagonTable.setAttribute(
          'style',
          'transform: scale(0.9);transform-origin: 0 0;width: 110%;margin-bottom: -25px;font-size:11px'
        )
      }
    }
    this.loadingInstance = this.$loading({ fullscreen: true })
    this.baseInfo = this.$route.query
    this.$i18n.locale = this.baseInfo.lang
    if (!this.baseInfo.id || !this.baseInfo.start || !this.baseInfo.end) {
      this.$message.error(this.$t('msg.missingQueryParams'))
      return
    }
    if (this.baseInfo.name) {
      document.title = this.$t('msg.myReportFillName', [this.baseInfo.name])
    } else {
      document.title = this.$t('msg.myReport')
    }
    if (this.baseInfo.phone) {
      this.baseInfo.phone = this.baseInfo.phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
    }
    // 固定写死hypo和hyper
    delete this.baseInfo.hyper
    delete this.baseInfo.hypo
    cgmApi
      .fetchAidexRecord({
        hyper: this.isEmptyQueryParams(this.baseInfo.hyper) ? 10 : this.baseInfo.hyper,
        hypo: this.isEmptyQueryParams(this.baseInfo.hypo) ? 3.9 : this.baseInfo.hypo,
        start_time: this.baseInfo.start,
        end_time: this.baseInfo.end,
        userId: this.baseInfo.id,
        timeZone: this.baseInfo.timeZone
      })
      .then((res) => {
        const { data, code, msg } = res.data
        if (code !== 1) {
          this.$message.error(msg)
          return
        }
        if (!data || !data?.mage) {
          this.$message.error('Insufficient data!')
          return
        }
        if (data && Object.keys(data).length !== 0) {
          this.cgmRecord = data
          this.startDate = dayjs(this.cgmRecord.beginDate).format('YYYY/MM/DD')
          this.endDate = dayjs(this.cgmRecord.endDate).format('YYYY/MM/DD')
          this.startDateTime = dayjs(this.cgmRecord.beginDate).format('MM.DD')
          this.endDateTime = dayjs(this.cgmRecord.endDate).format('MM.DD')
          this.totalPerDayCount = this.cgmRecord.type ? 1440 : 288
          const totalNum = this.dataFirstPage(this.cgmRecord.num)
          this.cgmActive = (totalNum && this.cgmRecord.glucose.length > 0) ? this.formatterIndicator((totalNum / (this.cgmRecord.glucose.length * this.totalPerDayCount) * 100)) : 0
          this.statisticRecord = this.getStatisticData()
        }
        this.$nextTick(() => {
          this.drawTirChart()
          this.drawAgpChart()
          this.drawGluChart()
          // this.drawMiniGluChart()
          this.drawMultiGluChart()
          // if (this.isChinaVersion()) {
          //   this.drawPentagonChart()
          //   this.drawAreaChart()
          //   this.drawDayPentagonChart()
          // }
          this.loadingInstance.close()
        })
      })
  }
}
</script>
<style lang="scss" scoped>
@page {
  size: A4;
  margin: 0 0 1cm 0;
}

.page-header-space {
  height: 2cm;
}
.page-footer-space {
  height: 0;
}

.panel {
  -webkit-print-color-adjust: exact;
  -moz-print-color-adjust: exact;
  color-adjust: exact;
}

.new-page {
  page-break-before: always;
}

.container {
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  box-sizing: content-box;
  line-height: normal;
  -webkit-print-color-adjust: exact;
  -moz-print-color-adjust: exact;
  color-adjust: exact;
  // box-shadow: 0 2px 12px 0 #d9d9d9;
  width: 21cm;
  min-height: 29.7cm;
  margin: 0 auto;
  border-radius: 2px;
  background-color: #fff;
  text-align: center;
  padding: 0 1cm;
  font-size: 14px;

  .header {
    color: #4d913c;
    font-size: 36px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      display: block;
      width: 45px;
      height: 45px;
      margin-right: 10px;
    }
  }

  .aviod-new-page {
    page-break-inside: avoid;
    overflow: auto;
  }

  .tips {
    page-break-inside: avoid;
    font-size: 14px;
    font-weight: 500;
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    line-height: 26px;
    position: relative;
    left: -22px;
    .border {
      width: 10px;
      margin-right: 10px;
      background-color: #4d913c;
    }
    .label {
      color: white;
      background-color: #4d913c;
      border-radius: 5px;
      padding: 0 20px;
    }
  }

  .tips-mt4 {
    margin-top: 70px;
  }

  .base-info {
    .info {
      width: 100%;
      display: flex;
      flex-direction: row;
      .person-info {
        width: 100%;
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        .info-item {
          width: 33%;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          margin-top: 5px;
          font-size: 12px;
        }
      }
      .device-info {
        width: 50%;
        .device-tip {
          color: #1a9796;
          text-align: left;
        }
      }
    }
  }

  #multi_glu {
    width: 100%;
    zoom: 0.88;
    height: 320px;
  }

  .agp-info {
    #agp {
      width: 110%;
      height: 300px;
      transform: scale(0.9);
      transform-origin: 0 0;
      margin-bottom: -40px;
    }
    .legend {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: 10px;
      .item {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 15px;

        .b1 {
          width: 30px;
          height: 2px;
          background-color: #05367f;
          margin-right: 5px;
        }
        .b2 {
          width: 30px;
          height: 15px;
          background-color: #7fa2d4;
          margin-right: 5px;
        }
        .b3 {
          width: 30px;
          height: 15px;
          background-color: #d2e1f2;
          margin-right: 5px;
        }
        .b4 {
          width: 30px;
          height: 8px;
          margin-right: 5px;
          border-top: 2px dashed #72b522;
          border-bottom: 2px dashed #72b522;
        }
      }
    }
  }

  .cgm-core {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: flex-start;
    height: 190px;
    margin-bottom: -50px;
    .left-panel {
      width: 45%;
      margin-top: 10px;
      transform: scale(0.7);
      transform-origin: 0 0;
      position: absolute;
      left: 0;
      table {
        width: 100%;
        height: 100%;
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 600;
        box-sizing: border-box;
        th {
          background-color: #4d913c;
          padding: 5px 0;
          color: white;
          font-size: 14px;
          border-right: 1px solid #d1d1d1;
          border-top: 1px solid #d1d1d1;
          box-sizing: border-box;
          &:first-child {
            border-left: 1px solid #d1d1d1;
          }
        }
        td {
          box-sizing: border-box;
          border-right: 1px solid #d1d1d1;
          border-bottom: 1px solid #d1d1d1;
          padding: 6px 0;

          &:nth-child(3) {
            text-align: left;
            padding-left: 10px;
            width: 60px;
          }

          &:first-child {
            border-left: 1px solid #d1d1d1;
            text-align: left;
            padding-left: 10px;
          }
        }
        tr:last-child {
          td {
            border-bottom: 1px solid #d1d1d1;
          }
        }
        .ghost {
          border-top: none;
          border-bottom: none;
          background-color: white;
        }
      }
    }
    .right-panel {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 26%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      transform: scale(0.8);
      transform-origin: 0 0;
      .tir-title {
        width: 100%;
        color: #426e06;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
      }
      .tir-panel {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;

        #tir {
          width: 60%;
          height: 100%;
        }
        .legend {
          height: 100%;
          position: absolute;
          right: 20px;
          .legend-item {
            line-height: 30px;
            max-width: 360px;
            text-align: left;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            &:nth-child(1) {
              .icon {
                background-color: #F59A24;
              }
            }
            &:nth-child(2) {
              .icon {
                background-color: #FFFD01;
              }
            }
            &:nth-child(3) {
              .icon {
                background-color: #0E9A33;
              }
            }
            &:nth-child(4) {
              .icon {
                background-color: #E56363;
              }
            }
            &:nth-child(5) {
              .icon {
                background-color: #CC5858;
              }
            }
          }
          .legend-item-long {
            line-height: 24px;
            white-space: pre-line;
          }
          .icon {
            width: 10px;
            height: 16px;
            margin-right: 10px;
          }
        }
      }
    }
  }

  .pentagon-panel {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-top: 5px;
    font-size: 14px;
    margin-bottom: -120px;
    .average {
      font-weight: 600;
      width: 50%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      #pentagon {
        width: 100%;
        height: 300px;
        // zoom: 0.6;
        transform: scale(0.6);
        transform-origin: 0 0;
        position: relative;
        left: -5px;
      }
    }
    .area {
      width: 50%;
      font-weight: 600;
      display: flex;
      flex-direction: column;
      align-items: center;
      > div:first-child {
        position: relative;
        right: 30px;
      }
      #area {
        width: 200%;
        height: 300px;
        // zoom: 0.6;
        transform: scale(0.6);
        transform-origin: 0 0;
        position: relative;
        left: 110px;
      }
    }
  }
  .day-pentagon {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    > div:first-child {
      width: 10%;
      display: flex;
      font-size: 12px;
      flex-direction: column;
      justify-content: center;
      font-weight: 500;
    }

    .day-pentagon-item {
      width: 9%;
      height: 60px;
      // margin: 10px 10px 0 0;
      // border: 1px solid #d9d9d9;
      position: relative;
      .chart {
        width: 100%;
        height: 100%;
      }
    }
  }
  .pentagon-table {
    width: 100%;
    zoom: 0.8;
    font-size: 12px;
    .chart {
      margin: 0 auto;
      width: 45px;
      height: 45px;
    }
    table {
      width: 100%;
      margin-bottom: 10px;
      th {
        // background-color: #f0f0f0;
        font-size: 14px;
        font-weight: 400;
        border-right: 1px solid #d1d1d1;
        border-bottom: 1px solid #d1d1d1;
        border-top: 1px solid #d1d1d1;
        &:first-child {
          border-left: 1px solid #d1d1d1;
        }
      }
      td {
        border-right: 1px solid #d1d1d1;
        border-bottom: 1px solid #d1d1d1;
        &:first-child {
          border-left: 1px solid #d1d1d1;
          > span:first-child {
            font-weight: 500;
          }
        }
      }
      tr:nth-last-child(even) {
        background-color: #f0f0f0;
      }
      tr:last-child {
        td {
          border-bottom: 1px solid #d1d1d1;
        }
      }
    }
  }
  .annotation {
    margin-top: 20px;
    background-color: #f2f2f2;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    text-align: left;
    padding: 10px;
    font-size: 10px;
    border: 1px solid #d7d7d7;
    font-size: 14px;
    zoom: 0.95;
    transform: scale(0.9);
    transform-origin: 0;
    width: 108%;
    margin-bottom: -20px;
    > div {
      line-height: 18px;
    }
  }

  .mini-glu-panel {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    .mini-day-glu-item {
      width: 18.2%;
      height: 60px;
      border-radius: 10px;
      box-shadow: 0 2px 2px 0 #d9d9d9;
      margin: 10px 10px 0 0;
      border: 1px solid #d9d9d9;
      position: relative;
      .date {
        position: absolute;
        right: 3px;
        top: 0;
        font-size: 12px;
        z-index: 100;
      }
      .chart {
        width: 100%;
        height: 100%;
      }
    }
  }
  .day-glu-item {
    // zoom: 0.85;
    transform: scale(0.85);
    transform-origin: 0 0;
    height: 285px;
    width: 118%;
    display: flex;
    flex-direction: column;
    background-color: #f7f9fc;
    // margin: 5px 0;
    // margin-top: 20px;
    margin-bottom: -24px;
    .chart-panel {
      margin-top: 5px;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      .date {
        height: 130px;
        width: 20px;
        // background-color: #4d913c;
        // color: white;
        border-radius: 15px;
        display: flex;
        align-items: center;
        margin-left: 15px;
        padding: 0 5px;
      }
      .en-date {
        height: 130px;
        width: 12px;
        word-break: break-all;
        border-radius: 15px;
        font-size: 16px;
        display: flex;
        align-items: center;
        margin-left: 15px;
        padding: 0 5px;
        display: flex;
        flex-direction: column;

        > div:first-child {
          line-height: 16px;
        }

        > div:last-child {
          word-break: normal;
        }
      }
      .chart {
        width: 100%;
        height: 200px;
      }
    }
    .event-panel {
      padding: 0 25px;
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      flex-wrap: wrap;
      img {
        width: 20px;
        height: 20px;
        margin-right: 2px;
      }
      div {
        margin: 5px 0 5px 10px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        .event-label {
          width: 140px;
          text-align: left;
          margin-left: 1px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .glu-event {
    margin-top: 5px;
    transform: scale(0.9);
    transform-origin: 0 0;
    width: 111%;
    margin-bottom: -15px;
    table {
      width: 100%;
      th {
        background-color: #f0f0f0;
        font-size: 14px;
        font-weight: 400;
        border-right: 1px solid #d1d1d1;
        border-bottom: 1px solid #d1d1d1;
        border-top: 1px solid #d1d1d1;
        &:first-child {
          border-left: 1px solid #d1d1d1;
        }
      }
      td {
        border-right: 1px solid #d1d1d1;
        border-bottom: 1px solid #d1d1d1;
        &:first-child {
          border-left: 1px solid #d1d1d1;
          text-align: left;
          > span:first-child {
            font-weight: 500;
          }
        }
      }
      tr:last-child {
        td {
          border-bottom: 1px solid #d1d1d1;
        }
      }
    }
    .comment {
      zoom: 0.9;
      text-align: left;
      font-weight: 400;
      margin-top: 10px;
    }
  }
  .glu-overview {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 12px;
    zoom: 0.85;
    width: 100%;
    box-sizing: border-box;
    table {
      width: 100%;
      page-break-inside: auto;
      th {
        font-weight: 400;
        border-right: 1px solid #d1d1d1;
        border-bottom: 1px solid #d1d1d1;
        border-top: 1px solid #d1d1d1;
        &:first-child {
          border-left: 1px solid #d1d1d1;
        }
      }
      td {
        border-right: 1px solid #d1d1d1;
        border-bottom: 1px solid #d1d1d1;
        &:first-child {
          border-left: 1px solid #d1d1d1;
          text-align: left;
          > span:first-child {
            font-weight: 500;
          }
        }
      }
      tr:nth-last-child(odd) {
        background-color: #f0f0f0;
      }
      tr:last-child {
        td {
          border-bottom: 1px solid #d1d1d1;
        }
      }
      tr {
          page-break-inside: avoid;
          page-break-after: auto;
      }
      thead {
        display: table-header-group; /* 确保表头显示在每一页的顶部 */
      }
      tfoot {
        display: table-footer-group; /* 确保表尾显示在每一页的底部 */
      }
      .bar-item {
        width: 25px;
        .highBar {
          height: 80px;
          max-width: 20px;
          background-color: #f99500;
          margin: 0 auto;
          position: relative;
          .normalBar {
            width: 100%;
            height: 30%;
            position: absolute;
            bottom: 0;
            background-color: #61a311;
          }
          .lowBar {
            width: 100%;
            height: 10%;
            position: absolute;
            bottom: 0;
            background-color: #d61a00;
          }
        }
      }
    }
  }

  .last-tip {
    display: flex;
    flex-direction: column;
    border: 1px solid #d1d1d1;
    padding: 10px;
    border-top: none;
    height: 110px;
    zoom: 0.9;
    .day-glu-overview {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: flex-end;
      margin-top: 5px;
      .block1 {
        width: 10px;
        height: 10px;
        background-color: #61a311;
        margin-right: 10px;
      }
      .block2 {
        width: 10px;
        height: 10px;
        background-color: #d61a00;
        margin-right: 10px;
      }
      .block3 {
        width: 10px;
        height: 10px;
        background-color: #f99500;
        margin-right: 10px;
      }

      .p1,
      .p2,
      .p3 {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 12px;
        text-align: left;
        margin-right: 20px;
      }
    }

    .gist {
      text-align: left;
      font-size: 12px;
      zoom: 0.96;
      margin-top: 10px;
    }
  }

  .divider {
    // zoom: 0.7;
    height: 152px;
    width: 2px;
    border-left: 1px dashed;
    right: 83px;
    top: 10px;
    position: absolute;
  }

  ::v-deep .el-divider {
    height: 180px;
    right: 90px;
    top: 20px;
    position: absolute;
  }

  .right {
    left: 64%;
  }

  @media print {
    // .base-info {
    //   zoom: 0.9;
    // }
    .annotation {
      zoom: 0.9;
    }
  }
}

.main-content {
  margin: 0 auto;
  box-shadow: 0 2px 12px 0 #d9d9d9;
}

#page-header {
  position: fixed;
  height: 2cm;
  top: 0;
  width: 100%;
  border-bottom: 1px dashed #f2f2f2;
  display: none;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-top: 5px;
  img {
    display: block;
    width: 45px;
    height: 45px;
    margin-left: 40px;
  }
  .info-one {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 10px;
    .title {
      color: #4294bf;
      font-size: 24px;
    }
    .name-panel {
      font-size: 12px;
      display: inline-flex;
      justify-content: flex-start;
    }
  }
  .info-one-en {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 10px;
    .title {
      color: #4d913c;
      font-size: 20px;
      position: relative;
      left: 15px;
    }
    img {
      display: block;
      width: 80px;
      height: 30px;
      margin-left: 0;
    }
  }
  .info-two {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    .left-info,
    .right-info {
      min-width: 200px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      div {
        margin-top: 10px;
        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
  .divider {
    height: 1.2cm;
    width: 2px;
    border-left: 1px dashed #f2f2f2;
    margin: 0 20px;
  }

  .divider-ghost {
    height: 1.2cm;
    width: 2px;
    margin: 0 20px;
  }
}
#page-footer {
  position: fixed;
  height: 0;
  bottom: 0;
  width: 100%;
  display: none;
}

@media print {
  #page-header,
  #page-footer {
    display: flex;
  }
  body {
    counter-reset: page;
    background-color: #fff;
    margin: 0;
  }

  // #page-footer:after {
  //   counter-increment: page;
  //   content: "Page " counter(page);
  // }

  .main-content {
    box-shadow: none;
  }
}
.ru {
  zoom: 0.9;
}
</style>
